import { BillingPeriod } from "@redotech/redo-billing-common/service-invoice";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export type ReturnsInvoiceStatus = z.infer<typeof returnsInvoiceStatus>;
export const returnsInvoiceStatus = z.object({
  period: createEnum(BillingPeriod),
  subscriptionPrice: z.number(),
  billingDueDate: z.date(),
  totalInvoiceAmount: z.number(),
});

export const getCurrentReturnsInvoice = {
  name: "getCurrentReturnsInvoice" as const,
  input: z.null(),
  output: returnsInvoiceStatus.nullable(),
};
